import {
  findNode,
  FormFieldDefinition,
  FormGroupDefinition,
  FormNode,
  StringFieldDefinition,
  UIElementDefinition,
} from '@msdk/definitions'

/**
 * Returns the width of the given element calculating the number of columns the group has
 * and the column span of the element
 * @param {UIElementDefinition} item - the ui element to analyze
 * @param {FormGroupDefinition} groupDef - the group definition containing the element
 * @param {FormNode} node - the form node representing the group
 */
export function getWidthOfElement(item: UIElementDefinition, groupDef: FormGroupDefinition, node: FormNode) {
  let columnSpan = parseInt(item.columnSpan.toString())
  const columns = parseInt(groupDef.columns.toString())
  if (columnSpan <= 0) {
    columnSpan = 1
    /*
     * Special case for string fields with IsComment="true"
     * these fields must occupy 100% of the group width
     */
    if (item.type === 'Field') {
      const formFieldDef = item as FormFieldDefinition
      const fieldNode = findNode(node, formFieldDef.name)
      if (fieldNode?.value.fieldDefinition?.fieldDefinitionType === 'String') {
        const stringDef = fieldNode.value.fieldDefinition as StringFieldDefinition
        const actualCols = columns === -1 ? 2 : columns
        columnSpan = stringDef.isComment ? actualCols : 1
      }
    }
  }
  if (columns === -1) {
    return { width: `${(100 / 2) * columnSpan}%` }
  } else {
    return { width: `${(100 / columns) * columnSpan}%` }
  }
}
